<app-loading *ngIf="cargando"></app-loading>
<div class="grid" *ngIf="!cargando">
  <div class="col-12 md:col-12 lg:col-12">
    <p-panel header="{{ 'ESTADOSCAUSAL.LBL_CONFIGURACIONESCAUSALES' | translate}}">
      <div class="grid form-group">
        <div class="col-12 lg:col-12 md:col-12">{{ 'ESTADOSCAUSAL.LBL_ESTADO' | translate }}: <strong>{{estado.nombre}}</strong></div>
      </div>
      <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fFormularioRol" name="nomFormularioRol">
        <div class="grid form-group">
          <div class="col-12 md:col-8 lg:col-8">
            <div class="div-form mt-1">
              <label>* {{ 'ESTADOSCAUSAL.LBL_LISTADOCAUSAL' | translate }}</label>
              <p-multiSelect id="idCausal" name="nomCausal" [options]="lisCausales"
                             defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                             selectedItemsLabel="{0} {{ 'LBL_ELEMENTOSSELECCIONADOS' | translate}}"
                             formControlName="idCausales"
                             emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                             emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                             optionValue="value"
                             optionLabel="label"
              ></p-multiSelect>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idCausales.invalid">
                {{ 'ESTADOSCAUSAL.LBL_LISTADOCAUSAL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>
          <div class="col-12 md:col-4 lg:col-4 mt-3">
            <button class="p-button-datatables" icon="fa fa-plus" label="{{'BTN_GUARDAR' | translate }}"
                    type="submit"
                    pButton></button>
          </div>
        </div>
      </form>

      <div class="grid">
        <div class="col-12 md:col-6 lg:col-6">
        </div>
        <div class="col-12 md:col-6 lg:col-6">
          <input #gb type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
                 (input)="dt.filterGlobal($event.target.value, 'contains')">
        </div>
      </div>

      <div class="grid">
        <div class="col-12 md:col-12 lg:col-12">
          <p-table [columns]="columnas" #dt
                   [value]="lisEstadoCausal"
                   [paginator]="true" [rows]="10"  paginatorPosition="bottom">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                  {{col.header}}
                  <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr [pSelectableRow]="row">
                <td>{{row.causalSolicitud}}</td>
                <td class="text-center">
                  <div class="btn-group" role="group">
                    <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                            title="{{'BTN_INHABILITAR' | translate}}" pButton
                            (click)="inhabilitar(row)"></button>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="columns.length" class="text-center">
                  {{ 'MSG_NOHAYREGISTROS' | translate}}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
      <div class="grid form-footer-buttons">
        <div class="form-group col-12">
          <button icon="fa fa-arrow-left" label="{{'BTN_REGRESAR' | translate }}"
                  type="button" (click)="regresar()"
                  pButton></button>
        </div>
      </div>
    </p-panel>
  </div>
</div>


<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
